export const trackUserLoginEvent = (action: string, userId: string = '') => {
    window.dataLayer?.push({
        event: 'loginEvent',
        eventCategory: 'Login',
        eventAction: action,
        userID: userId
    });
}
